import LogoIcon from './LogoIcon'
import Picture from './Picture'
import TaskLoading from './TaskLoading'
import LoadingButton from './LoadingButton'

export function installComponents (Vue) {
  Vue.component('yz-picture', Picture)
  Vue.component('yz-spinner', LogoIcon)
  Vue.component('yz-task-loading', TaskLoading)
  Vue.component('yz-loading-button', LoadingButton)
}




// WEBPACK FOOTER //
// ./src/components/global/index.js